// Firebase Configuration for AAR Guest Management System
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Origins whose /__/auth/handler is registered as a redirect URI on the Azure
// app registration (client 94bbca42-...). Firebase Hosting serves the handler on
// every domain attached to the project, but Microsoft only redirects back to a
// URI that is registered — so this list tracks Azure, not Hosting.
const AUTH_HANDLER_ORIGINS = [
  "btagms.brooklyntab.org",
  "btagms.web.app"
];

// Used when the app is served from an origin not in the list above: localhost
// during `npm start`, and btagms.firebaseapp.com, which Hosting still serves the
// app on. Must itself be a registered origin.
const FALLBACK_AUTH_DOMAIN = "btagms.brooklyntab.org";

// Run the OAuth popup on the same origin that served the app, when we can.
//
// WHY: this used to be pinned to "btagms.firebaseapp.com". Since the app is
// served from btagms.brooklyntab.org, and web.app/firebaseapp.com are both on
// the public suffix list, that made the sign-in popup cross-site on every
// sign-in. Firebase's hosted handler keeps its OAuth state in sessionStorage on
// the handler's origin across the redirect to Microsoft, and its storage
// constructor silently falls back to an in-memory object when that store can't
// be built — which cross-site storage partitioning provokes. The state then dies
// at the redirect and the popup fails with "Unable to process request due to
// missing initial state". Same-origin handler, no partitioning, no fallback.
//
// Adding a domain here without registering it in Azure gives AADSTS50011 on
// every sign-in from it, so Azure leads and this list follows.
function resolveAuthDomain() {
  if (typeof window === "undefined") return FALLBACK_AUTH_DOMAIN;
  const host = window.location.hostname;
  return AUTH_HANDLER_ORIGINS.includes(host) ? host : FALLBACK_AUTH_DOMAIN;
}

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA1maZFGVFB3J_V2AaHR2JzrNCXFP9hVYI",
  authDomain: resolveAuthDomain(),
  projectId: "btagms",
  storageBucket: "btagms.firebasestorage.app",
  messagingSenderId: "324531753860",
  appId: "1:324531753860:web:95febe82ac71aad10103d1",
  measurementId: "G-1GBRTER76X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'us-east1');
const storage = getStorage(app);

// Analytics starts only once the browser reports online. Calling getAnalytics
// while navigator.onLine is false makes Firebase Installations reject with
// installations/app-offline, an uncaught error on every page load. Some
// browsers report offline while the network works, so wait for the online
// event rather than giving up. Nothing in the app reads analytics directly;
// it only collects page views.
let analytics = null;
const startAnalytics = () => {
  isSupported()
    .then((supported) => {
      if (supported && !analytics) analytics = getAnalytics(app);
    })
    .catch(() => {
      // Analytics is optional; never let it surface an error.
    });
};
if (navigator.onLine === false) {
  window.addEventListener('online', startAnalytics, { once: true });
} else {
  startAnalytics();
}

export { app, analytics, auth, db, functions, storage };
